import React from "react";
import Marquee from "react-fast-marquee";

const slogans = [
  "APEXFRAMEZ",
  "YOUR VISION, BUILT",
  "PRECISION ENGINEERED",
  "BRICK BY BRICK",
  "PIT LANE READY",
  "MUMBAI · INDIA",
];

export default function KineticMarquee() {
  return (
    <section
      className="border-y border-white/10 bg-black py-8 af-marquee-fade"
      data-testid="kinetic-marquee"
    >
      <Marquee speed={60} gradient={false}>
        {Array.from({ length: 3 }).map((_, repeat) => (
          <div key={repeat} className="flex items-center">
            {slogans.map((s, i) => (
              <span key={`${repeat}-${i}`} className="flex items-center">
                <span className="af-display text-5xl md:text-7xl font-black uppercase tracking-tighter af-outline-text px-8">
                  {s}
                </span>
                <span className="text-[#FF2800] af-display text-5xl md:text-7xl font-black px-2">
                  ●
                </span>
              </span>
            ))}
          </div>
        ))}
      </Marquee>
    </section>
  );
}
